(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;

  function onInView(el, cb) {
    if (REDUCE || !HAS_IO) { cb(); return; }
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.top < vh && r.bottom > 0) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); cb(); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }

  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function initCount(root) {
    var els = (root || document).querySelectorAll('[data-count]:not([data-count-done])');
    Array.prototype.forEach.call(els, function (el) {
      var raw = (el.textContent || '').trim();
      var m = raw.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/);
      el.setAttribute('data-count-done', '');
      if (!m) { return; }

      var pre = m[1];
      var numStr = m[2];
      var suf = m[3];
      var hasGroup = numStr.indexOf(',') > -1;
      var clean = numStr.replace(/,/g, '');
      var dotAt = clean.indexOf('.');
      var dec = dotAt > -1 ? (clean.length - dotAt - 1) : 0;
      var end = parseFloat(clean);
      if (isNaN(end)) { return; }
      var dur = parseInt(el.getAttribute('data-count-duration'), 10) || 1400;

      function render(v) {
        var s = v.toFixed(dec);
        if (hasGroup) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        el.textContent = pre + s + suf;
      }

      onInView(el, function () {
        if (REDUCE) { el.textContent = raw; return; }
        var t0 = null, raf;
        raf = requestAnimationFrame(function tick(ts) {
          if (t0 === null) t0 = ts;
          var t = Math.min(1, (ts - t0) / dur);
          render(end * easeOutQuart(t));
          if (t < 1) raf = requestAnimationFrame(tick);
          else el.textContent = raw;
        });
        setTimeout(function () { cancelAnimationFrame(raf); el.textContent = raw; }, dur + 200);
      });
    });
  }

  function start() { initCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (e) { initCount(e.target); });

  window.EugeneMotion = { refreshCount: initCount };
})();
